import type { AxiosInstance } from 'axios'

import { CreateCategoryInputInterface } from '../../interfaces/category'

export const createCategory = (api: AxiosInstance) => (
  categoryDetail: CreateCategoryInputInterface
) => api.post('/v1.0/admin/categories', categoryDetail)
